export enum AirExchangeStatus {
    NOT_DEFIENED = 'Не определен',
    WORK = 'Действует',
    DECLINED = 'Действует. Отменен в части',
    NOT_WORK = 'Не действует',
    EMPTY = 'Без статуса'
  }
  